import { render, staticRenderFns } from "./CriarAgenda.vue?vue&type=template&id=b1ad4bce&"
import script from "./CriarAgenda.vue?vue&type=script&lang=js&"
export * from "./CriarAgenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports